<script lang="ts" setup>
import { inject } from 'vue'
import { useGotoBack } from '@/composables'

defineProps<{
  bookName?: string
  chapterName?: string
  isInShelf?: boolean
  shelfLoading?: boolean
}>()

const emit = defineEmits<{
  (e: 'click-book'): void
  (e: 'toggle-shelf'): void
}>()

const gotoBack = useGotoBack()
const theme = inject<{ background: string }>('theme', { background: 'white' })
</script>

<template>
  <div
    class="w-full h-36px flex items-center pl-8px pr-20px"
    :style="`background: ${theme.background}`"
  >
    <!-- 返回 -->
    <div class="p-1 cursor-pointer" @click="gotoBack()">
      <i-icon-park-outline-left class="w-5 h-5 chapter-breadcrumb__primary-icon" />
    </div>

    <!-- 书名 + 章节号 -->
    <div class="flex-1 min-w-0 flex items-center text-14px font-bold lh-20px">
      <span
        class="truncate chapter-breadcrumb__secondary cursor-pointer max-w-50%"
        @click="emit('click-book')"
      >
        {{ bookName }}
      </span>
      <span class="truncate chapter-breadcrumb__primary ml-1 flex-1">
        /{{ chapterName }}
      </span>
    </div>

    <!-- 加入书架 -->
    <div
      class="ml-2 p-1 -mr-1 cursor-pointer flex items-center"
      :class="{ 'opacity-50 pointer-events-none': shelfLoading }"
      @click="emit('toggle-shelf')"
    >
      <i-assets-book-add-shelf
        class="w-22px h-22px"
        :class="isInShelf ? 'chapter-breadcrumb__accent-icon' : 'chapter-breadcrumb__primary-icon'"
      />
    </div>
  </div>
</template>

<style>
.chapter-breadcrumb__primary {
  color: var(--chapter-nav-primary, #32353A) !important;
}

.chapter-breadcrumb__secondary {
  color: var(--chapter-nav-secondary, #969CAA) !important;
}

.chapter-breadcrumb__primary-icon,
.chapter-breadcrumb__primary-icon * {
  color: var(--chapter-nav-primary, #32353A) !important;
}

.chapter-breadcrumb__accent-icon,
.chapter-breadcrumb__accent-icon * {
  color: var(--theme-radio-border, var(--primary-color)) !important;
}
</style>
